import React, { useEffect, useState } from 'react';
import { Alert, FormControlLabel, Paper, Switch, Typography } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import { SupplierPortalAdminService, SupplierPortalSettings } from '../../../services/supplierPortalAdmin.service';
import { useToast } from '../../../context/ToastContext';
import { usePermission } from '../../../hooks/usePermission';
import { PERMISSIONS } from '../../../constants/permissions';

// ---- F8: supplier portal on/off (needs SUPPLIER_PORTAL_MANAGE + PROCUREMENT_SETTINGS_MANAGE) ----
const SupplierPortalSettingsCard: React.FC = () => {
  const institutionId = AuthService.getSelectedInstitution() as string;
  const toast = useToast();
  const canManage = usePermission(PERMISSIONS.SUPPLIER_PORTAL_MANAGE);
  const [s, setS] = useState<SupplierPortalSettings | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!canManage) return;
    SupplierPortalAdminService.getSettings(institutionId).then(setS)
      .catch(e => toast.showApiError(e, 'Failed to load supplier portal settings'));
  }, [institutionId, canManage]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!canManage || !s) return null;
  const toggle = async (on: boolean) => {
    setBusy(true);
    try { setS(await SupplierPortalAdminService.saveSettings(institutionId, on)); toast.showSuccess(on ? 'Supplier portal on' : 'Supplier portal off'); }
    catch (e) { toast.showApiError(e, 'Failed to save'); }
    finally { setBusy(false); }
  };
  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h6">Supplier portal</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Invited supplier contacts can see and acknowledge their purchase orders and send bills for review.
      </Typography>
      {!s.serverConfigured && <Alert severity="warning" sx={{ mb: 1 }}>The portal is not configured on this server.</Alert>}
      <FormControlLabel label="Supplier portal on"
        control={<Switch data-help="procurement.portalSettings.field.enabled" checked={s.supplierPortalEnabled} disabled={busy || !s.serverConfigured} onChange={(_, c) => toggle(c)} />} />
    </Paper>
  );
};

export default SupplierPortalSettingsCard;
// ---- end F8 ----
